import { replaceUrl, updateUrlParams } from './index';
import { pick } from '@fxts/core';

export class QueryController<T extends Record<string, any>> {
  private query: T;

  /**
   * to pick keys from `query`
   */
  private readonly allowed_keys?: (keyof T)[];

  constructor(query: Readonly<T>, allowed_keys?: (keyof T)[]) {
    this.query = query;
    this.allowed_keys = allowed_keys;
  }

  public getQuery(): Readonly<T> {
    return this.query;
  }

  public setQuery(partial: Partial<T>): this {
    this.query = {
      ...this.query,
      ...this.pickAllowedKeys(partial),
    };

    return this;
  }

  /**
   * Call on browser
   */
  public syncQuery(): this {
    const updated_url = updateUrlParams(location.href, this.query);
    replaceUrl(updated_url);

    return this;
  }

  private pickAllowedKeys(data: Partial<T>): Partial<T> {
    if (this.allowed_keys) {
      return pick(this.allowed_keys, data);
    }
    return data;
  }
}
